<template>
  <div class="cooperate">
    <headers></headers>
    <div class="cooperate-info1">
      <div class="cooperate-info2" @mouseover="flag=1" :class="flag == 1 ? 'is-hover' : '' ">
        <router-link to="/weChat">
          <div class="cooperate-info3" style="transform: translateX(-5px);">
            <span class="iconfont" style="font-size:66px;">&#xe761;</span>
          </div>
          <p>微信公众号</p>
          <p>活动版面</p>
          <div class="cooperate-info4">
            <button>点击申请</button>
          </div>
        </router-link>
      </div>
      <div class="cooperate-info2" @mouseover="flag=2" :class="flag == 2 ? 'is-hover' : '' ">
        <router-link to="/cash">
          <div class="cooperate-info33">
            <span class="iconfont" style="font-size:70px">&#xe76d;</span>
          </div>
          <p>收银机</p>
          <p>客显广告位</p>
          <div class="cooperate-info4">
            <button>点击申请</button>
          </div>
        </router-link>
      </div>
      <div class="cooperate-info2" @mouseover="flag=3" :class="flag == 3 ? 'is-hover' : '' ">
        <router-link to="/business">
          <div class="cooperate-info33">
            <span class="iconfont" style="font-size:70px">&#xe710;</span>
          </div>
          <p>其他</p>
          <p>商务合作</p>
          <div class="cooperate-info4">
            <button>点击申请</button>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="smallinfo">
      <ul>
        <li>
          <router-link to="/weChat">
            <span class="iconfont">&#xe761;</span>
            <i>微信公众号 活动版面</i>
            <button>点击申请</button>
          </router-link>
        </li>
        <li>
          <router-link to="/cash">
            <span class="iconfont">&#xe76d;</span>
            <i>收银机 客显广告位</i>
            <button>点击申请</button>
          </router-link>
        </li>
        <li>
          <router-link to="/business">
            <span class="iconfont">&#xe710;</span>
            <i>其他 商务合作</i>
            <button>点击申请</button>
          </router-link>
        </li>
      </ul>
    </div>
    <footers style="margin-top:100px;"></footers>
  </div>
</template>

<script>
import footer from "../components/footer";
import header from "../components/headers";

export default {
  name: "",
  components: {
    footers: footer,
    headers: header
  },
  data() {
    return {
      flag: 2
    };
  },

  methods: {},
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
@font-face {
  font-family: "iconfont";
  src: url("../assets/iconfont/font_home/iconfont.eot");
  src: url("../assets/iconfont/font_home/iconfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/iconfont/font_home/iconfont.woff2") format("woff2"),
    url("../assets/iconfont/font_home/iconfont.woff") format("woff"),
    url("../assets/iconfont/font_home/iconfont.ttf") format("truetype"),
    url("../assets/iconfont/font_home/iconfont.svg#iconfont") format("svg");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
a {
  text-decoration: none;
}
.cooperate {
  width: 100%;
  height: 100%;
  margin-top: 60px;
  .cooperate-info1 {
    min-width: 1140px;
    width: 60%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .cooperate-info2 {
      width: 32%;
      height: 410px;
      border: 1px solid #258ffc;
      border-radius: 2px;
      box-shadow: 0px 4px 5px 0px rgba(37, 143, 252, 0.2);
      margin: 120px 0;
      cursor: pointer;
      .cooperate-info3 {
        width: 55px;
        height: 58px;
        margin: 30px auto;
        // margin-top: 50px;
        // margin: 50px auto 0;
        span {
          font-size: 50px;
          color: #258ffc;
        }
      }
      p {
        width: 150px;
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(37, 143, 252, 1);
        line-height: 48px;
        text-align: center;
        margin: 0 auto;
        &:nth-of-type(1) {
          margin-top: 40px;
        }
      }
      .cooperate-info4 {
        width: 150px;
        height: 50px;
        margin: 0 auto;
        margin-top: 70px;
        background: #fff;
        overflow: hidden;
        border-radius: 2px;
        button {
          width: 100%;
          height: 100%;
          border: 1px solid rgba(37, 143, 252, 1);
          font-size: 24px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(37, 143, 252, 1);
          line-height: 28px;
          text-align: center;
          outline: none;
          background: none;
          border-radius: 4px;
        }
      }
      .cooperate-info33 {
        width: 60px;
        height: 58px;
        margin: 30px auto;
        span {
          font-size: 50px;
          color: #258ffc;
        }
      }
    }
    .is-hover {
      background: #258ffc;
      p {
        color: #fff !important;
      }
      span {
        color: #fff !important;
      }
    }
  }
  @media screen and (max-width: 850px) {
    margin-top: 30px;
    .cooperate-info1 {
      display: none;
    }
  }
  @media screen and (min-width: 850px) {
    .smallinfo {
      display: none;
    }
  }
  .smallinfo {
    padding: 0 15px;
    ul {
      li {
        border-radius: 3.5px;
        border: 1px solid #258ffc;
        box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2);
        margin: 16px 0;

        a {
          display: block;
          width: 100%;
          height: 100%;
          padding: 25px 15px;
          span {
            font-size: 35px;
            color: #258ffc;
          }
          i {
            display: inline-block;
            font-style: normal;
            transform: translateY(-5px);
            color: #258ffc;
            margin-left: 5px;
          }
          button {
            float: right;
            border-radius: 3.5px;
            border: 1px solid #258ffc;
            width: 75px;
            height: 25px;
            background-color: transparent;
            color: #258ffc;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>
